import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

/**
 * ButtonText (span)
 */
export const ButtonText = styled.span.attrs(
	({
		large,
		color,
		hide,
		forcedFontSize,
		forcedFontSizeSmall,
		forcedLineHeight,
		weight,
		display,
		opacity,
		theme,
	}) => ({
		fontSize: large ? "30px" : "18px",
		color: color ? color : theme.colors.black,
		display: "inline-block",
		opacity: hide ? 0 : 1,
		forcedFontSize: forcedFontSize ? forcedFontSize : undefined,
		forcedFontSizeSmall: forcedFontSizeSmall ? forcedFontSizeSmall : undefined,
		forcedLineHeight: forcedLineHeight,
	})
)`
	font-family: ${({ theme }) => theme.font};
	color: ${({ color }) => color};
	font-weight: ${({ weight }) => (weight ? weight : "bold")};
	padding: ${({ padding }) => (padding ? padding : "0 0.5rem")};
	font-size: ${({ forcedFontSize, fontSize, forcedFontSizeSmall }) =>
		forcedFontSizeSmall ? forcedFontSizeSmall : forcedFontSize ? forcedFontSize : fontSize};
	line-height: ${({ forcedLineHeight }) => (forcedLineHeight ? forcedLineHeight : "1.5em")};
	display: ${({ display }) => display};
	opacity: ${({ opacity }) => opacity};
	transition: 0.2s ease;

	${media.greaterThan(breakpoints.ipad)`
		font-size: ${({ forcedFontSize, fontSize }) => (forcedFontSize ? forcedFontSize : fontSize)};
	`}

	${({ blur }) => (blur ? "filter: blur(2px);" : "")};
	&:hover {
		cursor: pointer;
	}
`;
